module.exports = __webpack_public_path__ + "static/media/mobility_too_low.0f861747.png";